import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppResponse } from '@data/app/response';
import { environment } from '@environments/environment';
import { ApiPaths } from '@mpg-core/constants/api-paths.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PickListAdminService {

  constructor(private http: HttpClient){}

  getCategorieByName(catName: any): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.pickListDetails + "/" + catName).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  getPicklist(catId: any): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.picklistDetailsByCategory + "/" + catId).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  savePickListDetail(data: any): Observable<any>{
    return this.http.post<any>(environment.apiUrl+ ApiPaths.saveOrUpdatePicklistDetail , data ).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  getVendors(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getVendorsForPicklist).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  saveVendor(data: any){
    return this.http.post<any>(environment.apiUrl+ ApiPaths.saveOrUpdateVendor , data ).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  getDeleteStatusOptions(){
    const deleteStatusOptions: any[] = [
      { id: "Y", name: "Inactive", value: true },
      { id: "N", name: "Active", value: false },
    ];
    return deleteStatusOptions;
  }
  
}
